import { PropsOf } from "@emotion/react";
import styled from "@emotion/styled";
import { IconSearch, Input } from "atoms";

function SearchBar({ className, ...props }: PropsOf<typeof SearchInput>) {
  return (
    <SearchGroup className={className}>
      <SearchIcon />
      <SearchInput
        placeholder="Search projects and artists"
        aria-label="Search projects and artists"
        role="combobox"
        {...props}
      />
    </SearchGroup>
  );
}

const SearchGroup = styled.div({
  marginTop: "2rem",
  position: "relative",
});

const SearchIcon = styled(IconSearch)({
  position: "absolute",
  left: ".66rem",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 1,
});

const SearchInput = styled(Input)(({ theme }) => ({
  borderColor: theme.colors.fg,
  margin: 0,
  paddingLeft: "2rem",
}));

export { SearchBar };
